import React from "react";

export const CallRecordsIcon: React.FC = () => {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <defs>
        <path
          d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
          id="path-1"
        ></path>
        <filter
          x="-54.2%"
          y="-45.8%"
          width="208.3%"
          height="208.3%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="4"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Provider-Global-navigation-V2.2"
          transform="translate(-13.000000, -199.000000)"
        >
          <g
            id="Care-Plan-menu-Copy-4"
            transform="translate(14.000000, 199.000000)"
          >
            <g id="call-record-icon" transform="translate(7.000000, 6.000000)">
              <g id="Rectangle-Copy-212">
                <use
                  fill="black"
                  fillOpacity="1"
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                ></use>
                <use
                  fill="#7CBA5B"
                  fillRule="evenodd"
                  xlinkHref="#path-1"
                ></use>
              </g>
              <path
                d="M15.7055502,15.0461546 L15.7057663,15.0308737 C15.7102166,14.8735438 15.5861883,14.7380189 15.4256752,14.7165247 C14.9106089,14.6543117 14.4048339,14.5386457 13.91608,14.3710732 C13.79287,14.328416 13.6539736,14.3556938 13.562942,14.4385761 L12.9446214,15.0080808 C12.7418508,15.1948429 12.4285874,15.2337913 12.1793104,15.103233 C10.8605467,14.4125327 9.76862045,13.4068132 9.01871584,12.1921648 C8.87745011,11.9633515 8.91892324,11.6758882 9.12016414,11.4889947 L9.73269229,10.9201378 C9.82523533,10.8339251 9.85485127,10.7059944 9.80782234,10.5907505 C9.62660142,10.1423447 9.50102103,9.67650019 9.4343703,9.20814044 C9.41064121,9.05393146 9.26656923,8.93976057 9.09172818,8.94118974 L7.63161943,8.94118932 C7.53699608,8.94129311 7.44677431,8.97801199 7.38298192,9.04238101 C7.31918952,9.10675002 7.28769752,9.19284508 7.29520853,9.27039229 C7.44444862,10.5651422 7.92270849,11.8093091 8.69423835,12.9064022 C9.39174919,13.9173757 10.3223581,14.7745137 11.42491,15.4198665 C12.6059966,16.125259 13.9502529,16.5656604 15.3380874,16.7046263 C15.4326348,16.7124787 15.5263959,16.6832588 15.5963421,16.6241433 C15.6662884,16.5650279 15.705939,16.481494 15.7055502,16.3916876 L15.7055502,15.0461546 Z M16.9996551,16.4750933 C17.0014949,16.9028936 16.8113235,17.3116043 16.4758492,17.6008417 C16.1403748,17.8900791 15.6906798,18.0330447 15.225581,17.9935382 C13.6221049,17.8298631 12.081841,17.3150853 10.7334785,16.4935431 C9.47331926,15.7411205 8.40491297,14.737249 7.60712427,13.5576065 C6.72652609,12.2802549 6.17853054,10.825969 6.00653971,9.30308208 C5.96578564,8.87838693 6.11682686,8.45714511 6.42278644,8.14220345 C6.72874603,7.8272618 7.16146554,7.64760537 7.61605725,7.64709715 L9.07660944,7.64712161 C9.88761179,7.64024587 10.5786064,8.1988558 10.6933137,8.95954934 C10.7485751,9.35548813 10.8513164,9.74428457 10.9988609,10.1167231 C11.2209891,10.6719655 11.0789458,11.2978988 10.6343941,11.7203793 L10.3723257,11.9686644 C10.9053072,12.7263598 11.5956841,13.3752236 12.4019193,13.8762276 L12.6686393,13.6256241 C13.1175735,13.2085814 13.7837455,13.0751179 14.3727628,13.2831543 C14.7710633,13.4224614 15.1848539,13.5189968 15.6148697,13.572039 C16.4228409,13.68213 17.0162591,14.3406031 16.9996603,15.106636 L16.9996551,16.4750933 Z"
                id="Icon_feather-phone-call"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
              <path
                d="M14.399819,11.7633484 C13.0885801,11.7633484 12.0256109,10.7003792 12.0256109,9.38914027 C12.0256109,8.07790132 13.0885801,7.01493213 14.399819,7.01493213 C15.711058,7.01493213 16.7740271,8.07790132 16.7740271,9.38914027 C16.7740271,10.7003792 15.711058,11.7633484 14.399819,11.7633484 Z M14.399819,10.5986425 C15.0678087,10.5986425 15.6093213,10.0571299 15.6093213,9.38914027 C15.6093213,8.72115062 15.0678087,8.17963801 14.399819,8.17963801 C13.7318294,8.17963801 13.1903167,8.72115062 13.1903167,9.38914027 C13.1903167,10.0571299 13.7318294,10.5986425 14.399819,10.5986425 Z"
                id="Oval"
                fill="#FFFFFF"
                fillRule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
